module.exports = __webpack_public_path__ + "static/media/bff3.aa7b3ca1.png";